(function () {
  'use strict';

  if (window.UnifiedHealth) {
    return;
  }

  const VERSION = '1.1.0';

  function checkModule(
    name,
    reference,
    requiredMethods
  ) {
    const available =
      Boolean(reference);

    const methods = {};

    (requiredMethods || []).forEach(
      function (methodName) {
        methods[methodName] =
          Boolean(
            reference &&
            typeof reference[
              methodName
            ] === 'function'
          );
      }
    );

    const missingMethods =
      Object.keys(
        methods
      ).filter(
        function (methodName) {
          return (
            methods[methodName] !==
            true
          );
        }
      );

    return {
      name: name,

      available:
        available,

      version:
        reference &&
        reference.version
          ? reference.version
          : '',

      methods:
        methods,

      missing_methods:
        missingMethods,

      healthy:
        available &&
        missingMethods.length === 0
    };
  }

  function checkConfig() {
    const config =
      window.UnifiedTrackingConfig;

    const issues = [];

    if (!config) {
      issues.push(
        'configuration_unavailable'
      );

      return {
        available: false,
        version: '',
        issues: issues,
        healthy: false
      };
    }

    if (!config.version) {
      issues.push(
        'version_missing'
      );
    }

    if (
      !config.providers ||
      typeof config.providers !==
        'object'
    ) {
      issues.push(
        'providers_missing'
      );
    }

    if (
      !config.events ||
      typeof config.events !==
        'object'
    ) {
      issues.push(
        'events_missing'
      );
    }

    return {
      available: true,

      version:
        config.version || '',

      debug:
        config.debug === true,

      consent_required:
        config.consentRequired ===
        true,

      events_count:
        config.events
          ? Object.keys(
              config.events
            ).length
          : 0,

      issues:
        issues,

      healthy:
        issues.length === 0
    };
  }

  function checkGA4() {
    const config =
      window.UnifiedTrackingConfig ||
      {};

    const enabled =
      Boolean(
        config.providers &&
        config.providers.ga4 === true
      );

    const available =
      typeof window.gtag ===
      'function';

    return {
      enabled: enabled,

      available: available,

      healthy:
        !enabled || available,

      status:
        !enabled
          ? 'disabled'
          : (
              available
                ? 'available'
                : 'unavailable'
            )
    };
  }

  function checkConsent() {
    const config =
      window.UnifiedTrackingConfig ||
      {};

    const required =
      config.consentRequired ===
      true;

    const shopifyAvailable =
      Boolean(
        window.Shopify &&
        window.Shopify
          .customerPrivacy
      );

    const methodAvailable =
      Boolean(
        shopifyAvailable &&
        typeof window.Shopify
          .customerPrivacy
          .analyticsProcessingAllowed ===
          'function'
      );

    let allowed = null;

    if (methodAvailable) {
      try {
        allowed =
          window.Shopify
            .customerPrivacy
            .analyticsProcessingAllowed();
      } catch (error) {
        return {
          required:
            required,

          api_available:
            true,

          allowed:
            null,

          healthy:
            false,

          status:
            'error',

          error:
            error.message
        };
      }
    }

    return {
      required:
        required,

      api_available:
        methodAvailable,

      allowed:
        allowed,

      healthy:
        !required ||
        methodAvailable,

      status:
        !required
          ? 'not_required'
          : (
              methodAvailable
                ? 'available'
                : 'unavailable'
            )
    };
  }

  function checkErrors() {
    const manager =
      window.UnifiedErrors;

    if (
      !manager ||
      typeof manager.getSummary !==
        'function'
    ) {
      return {
        available: false,
        healthy: false,
        summary: null
      };
    }

    const summary =
      manager.getSummary();

    return {
      available: true,

      healthy:
        summary.fatal === 0,

      summary:
        summary
    };
  }

  function checkPerformance() {
    const monitor =
      window.UnifiedPerformance;

    if (
      !monitor ||
      typeof monitor.getSummary !==
        'function'
    ) {
      return {
        available: false,
        healthy: false,
        summary: null
      };
    }

    const summary =
      monitor.getSummary();

    return {
      available: true,

      healthy:
        summary.active_measurements ===
        0,

      summary:
        summary
    };
  }

  function checkBus() {
    const bus =
      window.UnifiedBus;

    if (
      !bus ||
      typeof bus.getStats !==
        'function'
    ) {
      return {
        available: false,
        healthy: false,
        summary: null
      };
    }

    const summary =
      bus.getStats();

    return {
      available: true,

      healthy:
        typeof bus.emit ===
          'function' &&
        typeof bus.on ===
          'function' &&
        typeof bus.off ===
          'function',

      summary:
        summary
    };
  }

  function getModules() {
    return {
      bus: checkModule(
        'bus',
        window.UnifiedBus,
        [
          'emit',
          'on',
          'once',
          'off',
          'getHistory',
          'getStats'
        ]
      ),

      debug: checkModule(
        'debug',
        window.UnifiedDebug,
        [
          'getHistory',
          'printHistory',
          'clearHistory'
        ]
      ),

      context: checkModule(
        'context',
        window.UnifiedContext,
        [
          'getContext',
          'getSessionId',
          'getPageSequence'
        ]
      ),

      errors: checkModule(
        'errors',
        window.UnifiedErrors,
        [
          'getSummary',
          'getAll',
          'clear'
        ]
      ),

      journey: checkModule(
        'journey',
        window.UnifiedJourney,
        [
          'getJourney',
          'getSummary',
          'getConversionPath'
        ]
      ),

      performance: checkModule(
        'performance',
        window.UnifiedPerformance,
        [
          'getSummary',
          'getMeasurements',
          'clear'
        ]
      ),

      tracking: checkModule(
        'tracking',
        window.UnifiedTracking,
        [
          'track',
          'emit',
          'getConfig',
          'getContext',
          'getErrors',
          'getPerformance',
          'getBusStats'
        ]
      ),

      detection: checkModule(
        'detection',
        window.UnifiedTracking &&
        window.UnifiedTracking.detect,
        [
          'currentPage',
          'currentService',
          'resolveService'
        ]
      )
    };
  }

  function calculateScore(checks) {
    const items = [];

    Object.keys(
      checks.modules
    ).forEach(
      function (key) {
        items.push(
          checks.modules[key]
            .healthy
        );
      }
    );

    items.push(
      checks.config.healthy
    );

    items.push(
      checks.ga4.healthy
    );

    items.push(
      checks.consent.healthy
    );

    items.push(
      checks.errors.healthy
    );

    items.push(
      checks.performance.healthy
    );

    items.push(
      checks.bus.healthy
    );

    const passed =
      items.filter(Boolean).length;

    const total =
      items.length;

    return {
      passed:
        passed,

      total:
        total,

      percentage:
        total
          ? Math.round(
              (
                passed / total
              ) * 100
            )
          : 0
    };
  }

  function getStatus() {
    const checks = {
      generated_at:
        new Date().toISOString(),

      framework_version:
        window
          .UnifiedTrackingConfig &&
        window
          .UnifiedTrackingConfig
          .version
          ? window
              .UnifiedTrackingConfig
              .version
          : '',

      config:
        checkConfig(),

      modules:
        getModules(),

      ga4:
        checkGA4(),

      consent:
        checkConsent(),

      errors:
        checkErrors(),

      performance:
        checkPerformance(),

      bus:
        checkBus()
    };

    checks.score =
      calculateScore(checks);

    checks.healthy =
      checks.score.percentage ===
      100;

    return checks;
  }

  function isHealthy() {
    return getStatus().healthy;
  }

  function printStatus() {
    const status =
      getStatus();

    const rows = [];

    rows.push({
      component: 'config',

      available:
        status.config.available,

      healthy:
        status.config.healthy,

      version:
        status.config.version ||
        ''
    });

    Object.keys(
      status.modules
    ).forEach(function (key) {
      const module =
        status.modules[key];

      rows.push({
        component:
          key,

        available:
          module.available,

        healthy:
          module.healthy,

        version:
          module.version || ''
      });
    });

    rows.push({
      component: 'ga4',

      available:
        status.ga4.available,

      healthy:
        status.ga4.healthy,

      version: ''
    });

    rows.push({
      component: 'consent',

      available:
        status.consent
          .api_available,

      healthy:
        status.consent
          .healthy,

      version: ''
    });

    console.table(rows);

    console.info(
      '[Unified Health] Health summary',
      {
        healthy:
          status.healthy,

        score:
          status.score
            .percentage + '%',

        passed:
          status.score.passed,

        total:
          status.score.total,

        bus:
          status.bus.summary,

        errors:
          status.errors.summary,

        performance:
          status.performance.summary
      }
    );

    return status;
  }

  window.UnifiedHealth = {
    version:
      VERSION,

    getStatus:
      getStatus,

    printStatus:
      printStatus,

    isHealthy:
      isHealthy
  };

  if (
    window.UnifiedTrackingConfig &&
    window.UnifiedTrackingConfig
      .debug
  ) {
    console.info(
      '[Unified Health] Health Monitor initialized',
      {
        version:
          VERSION
      }
    );
  }
})();